import React from 'react';
import { node, string, bool } from 'prop-types';
import { ThemeProvider } from 'theme-ui';
import Helmet from 'components/Helmet';
import FlashBanner from 'components/FlashBanner';

import theme from 'gatsby-plugin-theme-ui';

import Waffles from './Waffles';

const Layout = ({
  backgroundColor,
  children,
  title,
  discoverable,
  description,
}) => (
  <ThemeProvider theme={theme}>
    <Helmet
      title={title}
      discoverable={discoverable}
      description={description}
    />
    <Waffles backgroundColor={backgroundColor}>
      <FlashBanner />
      {children}
    </Waffles>
  </ThemeProvider>
);

Layout.defaultProps = {
  backgroundColor: null,
  title: null,
  discoverable: true,
  description: null,
};

Layout.propTypes = {
  backgroundColor: string,
  children: node.isRequired,
  title: string,
  discoverable: bool,
  description: string,
};

export default Layout;
